import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import {
  get_limit_report,
  getGCB,
  subassets,
  getAmenitiesType,
} from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "../api/constant";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import pdfLogo from "../images/login1.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const LimitReport = ({ role, mainId, userData }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [ExistAssetsType, setExistAssetsType] = useState([]);
  const [AssetsTypes, setAssetsTypes] = useState([]);
  const [postAmenityName, setPostAmenityName] = useState("");
  const [AssetsSubTypes, setAssetsSubTypes] = useState([]);
  const [AssetsType, setAssetsType] = useState("");
  const [error, setError] = useState(null);
  const [gbcType, setGcbType] = useState("");
  const [gcb, setGcb] = useState([]);
  const [yearsCons, setYearsCons] = useState([]);
  const [yearCons, setYearCons] = useState("");
  const [hostels, setHostels] = useState([]);
  const [hostelType, setHostelType] = useState("");
  const [markRequired, setMarkRequired] = useState(true);

  const AssetTypehandle = async (e) => {
    const selectedValue = e.target.value;
    console.log(selectedValue);

    if (!selectedValue) {
      setAssetsType("");
    }

    try {
      const amenities = JSON.parse(selectedValue);
      console.log(amenities);

      const amenityId = amenities.amenity_id;
      setAssetsType(amenityId);

      const amenityName = amenities.name;
      setPostAmenityName(amenityName);

      console.log("AssetsType", amenityId);

      const response = await subassets({ amenity_id: amenityId });
      if (response) {
        setAssetsSubTypes(response.data.asset_name);
      } else {
        console.error("Invalid response format for subassets:", response);
      }
    } catch (error) {
      console.error("Error fetching subassets:", error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    get_limit_report(userData.data.UDISE_code)
      .then((response) => {
        console.log(response);
        if (response.status == "success") {
          setIsLoading(false);
          setFilteredData(response.data.result);
          setRows(response.data.result);
        } else {
          setIsLoading(false);
          setFilteredData([]);
          setRows([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });

    getGCB()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setGcb(res.data.student_gbc_master);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  useEffect(() => {
    getAmenitiesType()
      .then((res) => {
        if (res.status === "success") {
          console.log("amenities data:", res.data);
          setAssetsTypes(res.data);
          setExistAssetsType(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  const handleHostelType = (event) => {
    setHostelType(event.target.value);
  };

  const handleGCBChange = async (e) => {
    setGcbType(e.target.value);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      gbc_id: e.target.value,
    };
    await axios
      .post("/get_year_of_cons_from_gbc_udise", data)
      .then((response) => {
        if (response.data.status == "success") {
          setYearsCons(response.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  const handleYear = (e) => {
    setYearCons(e.target.value);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      gbc_id: gbcType,
      yoc: e.target.value,
    };
    console.log(data);
    axios
      .post("/get_hostel_type_from_udise_gbc_yoc", data)
      .then((response) => {
        if (response.data.status == "success") {
          setHostels(response.data.data.result);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let navigate = useNavigate();
  const view = (id) => {
    navigate(`/${role !== 5 ? "admin" : "dealer"}/admindetails/${id}`);
  };

  const exportPDF = () => {
    const doc = new jsPDF();

    const title = "SC/ST Department, Odisha";
    const reportName = "Allocated Limits Report";
    const tableColumn = [
      "Sr. No.",
      "School Name",
      "Amenity Type",
      "Amenity Sub Type Name",
      "Limit Allocated",
      "Limit Used",
      "Limit Remaining",
    ];
    const tableRows = [];

    // Load your logo (replace 'path/to/your/logo.png' with actual path or base64 string)
    const logoUrl = pdfLogo; // Change this URL or use base64 image data
    doc.addImage(logoUrl, "PNG", 10, 10, 30, 30); // Adjust dimensions as needed

    // Calculate the center position for the title vertically with respect to the logo
    const titleHeight = 10 + 15; // Adjust this depending on your logo's height + some margin
    const titleRepHeight = 10 + 50;
    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    const fromLeft = 130; // Adjust depending on the size and placement of your logo
    const fromRepLeft = 80;

    filteredData.forEach((row, index) => {
      const rowData = [
        index + 1,
        row.school_name,
        row.amenities_type,
        row.amenities_sub_type_name,
        row.total_limit,
        row.limit_used,
        row.limit_balance,
      ];
      tableRows.push(rowData);
    });

    doc.setFontSize(16); // Sets the font size to 16 points for the title
    doc.text(title, fromLeft, titleHeight); // Position the title next to the logo
    doc.setFontSize(12);
    doc.text(reportName, fromRepLeft, titleRepHeight);
    doc.setFontSize(12); // Resets the font size for the table
    doc.autoTable(tableColumn, tableRows, { startY: 70 }); // Start the table 100px below the logo and title
    doc.save("allocated_limits_report.pdf");
  };

  const exportExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Limit Report");

    // Add title
    worksheet.mergeCells("A1:G1");
    const titleRow = worksheet.getRow(1);
    titleRow.getCell(1).value = "Limit Report";
    titleRow.getCell(1).font = { bold: true, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: "center" };

    // Add headers
    const headers = [
      "Sr. No.",
      "School Name",
      "Amenity Type",
      "Amenity Sub Type Name",
      "Limit Allocated",
      "Limit Used",
      "Limit Remaining",
    ];
    // worksheet.addRow([]); // Add empty row for spacing
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "003366" }, // Blue background color
      };
      cell.font = {
        color: { argb: "FFFFFF" }, // White text color
        bold: true,
      };
    });

    // Add data
    filteredData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.school_name,
        row.amenities_type,
        row.amenities_sub_type_name,
        parseInt(row.total_limit),
        parseInt(row.limit_used),
        parseInt(row.limit_balance),
      ]);
    });

    // Set workbook properties
    workbook.creator = "Your Name";
    workbook.lastModifiedBy = "Your Name";
    workbook.created = new Date();
    workbook.modified = new Date();

    // Generate Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileName = "allocated_limits_report.xlsx";
      saveAs(blob, fileName);
    });
  };

  const getStocksData = () => {
    setIsLoading(true);

    if (!gbcType) {
      toast.error("Please Select GBC Type");
    } else if (!yearCons) {
      toast.error("Please Select Year Of Construction");
    } else if (!hostelType) {
      toast.error("Please Select Hostel Type");
    } else if (!AssetsType) {
      toast.error("Please Select Amenity Type");
    }

    let apiUrl = `/get_limit_report/?UDISE_code=${userData.data.UDISE_code}`;
    if (AssetsType) {
      apiUrl += `&amenities_id=${AssetsType}`;
    }
    if (hostelType) {
      apiUrl += `&hostel_id=${hostelType}`;
    }
    if (gbcType) {
      apiUrl += `&gbc_id=${gbcType}`;
    }
    if (yearCons) {
      apiUrl += `&year_of_const=${yearCons}`;
    }

    axios
      .get(apiUrl)
      .then((response) => {
        if (response.data.status === "success") {
          setFilteredData(response.data.data.result);
          setRows(response.data.data.result);
        } else {
          setFilteredData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4 ">{t("Allocated Limits Report")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px",
              }}
            />
          </div>
        </div>
        <div className="d-flex flex-driection-row">
          <div className="col-md-2 mt-3">
            <label className="form-label">
              {t("GBC Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="gbc_type"
              value={gbcType}
              className="common-input form-select"
              onChange={handleGCBChange}
              required
            >
              <option value="">{t("Select GBC Type")}</option>
              {gcb.map((item) => (
                <option value={item.id}>{t(item.type)}</option>
              ))}
            </select>
          </div>

          <div className="col-md-2 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Year of Construction")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="yearCons"
              className="common-input form-select"
              value={yearCons}
              onChange={handleYear}
              required
            >
              <option value="">{t("Year of Construction")}</option>
              {yearsCons.map((item) => (
                <option value={item.year_of_const}>
                  {t(item.year_of_const)}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Hostel Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="hostelType"
              className="common-input form-select"
              value={hostelType}
              onChange={handleHostelType}
              required
            >
              <option value="">{t("Select Hostel Type")}</option>
              {hostels.map((item) => (
                <option value={item.hostel_id}>{t(item.hostel_type)}</option>
              ))}
            </select>
          </div>
          {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <label className="form-label" htmlfor="title">
                {t("Academic Year")}
              </label>
              <select
                name="district" // value={AssetsType}
                className="common-input form-select"
              >
                <option value="" selected={true}>
                  {t("2023-24")}
                </option>
              </select>
            </div>
          </div> */}
          <div className="col-md-3 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label" htmlfor="title">
              {t("Amenity Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="aminity_type"
              className="common-input form-select"
              onChange={AssetTypehandle}
            >
              <option value="">{t("Select Amenity Type")}</option>
              {AssetsTypes.assets_name &&
                AssetsTypes.assets_name.map((row, index) => (
                  <option key={index} value={JSON.stringify(row)}>
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <button
            className="btn btn-primary btn-sm mx-5"
            style={{ marginTop: "45px", width: "7%" }}
            onClick={getStocksData}
          >
            Search
          </button>
        </div>

        <div class="col-md-12 mt-4 d-flex">
          <div class="d-flex justify-content-start align-items-center">
            <Button variant="contained" color="primary" onClick={exportPDF}>
              Download PDF
            </Button>
            <span class="mx-2"></span>
            <Button variant="contained" color="success" onClick={exportExcel}>
              Download Excel
            </Button>
          </div>
        </div>

        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("School Name")}</TableCell>
                  <TableCell align="left">{t("Amenity Type")}</TableCell>
                  <TableCell align="left">
                    {t("Amenity Sub Type Name")}
                  </TableCell>
                  <TableCell align="left">{t("Limit Allocated")}</TableCell>
                  <TableCell align="left">{t("Limit Used")}</TableCell>
                  <TableCell align="left">{t("Limit Remaining")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {getSerialNumber(index)}
                      </TableCell>
                      <TableCell align="left">{row.school_name}</TableCell>
                      <TableCell align="left">{row.amenities_type}</TableCell>
                      <TableCell align="left">
                        {row.amenities_sub_type_name}
                      </TableCell>
                      <TableCell align="left">{row.total_limit}</TableCell>
                      <TableCell align="left">{row.limit_used}</TableCell>
                      <TableCell align="left">{row.limit_balance}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default LimitReport;
